import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { v4 as uuidv4 } from 'uuid';

declare const google: any;

@Component({
  selector: 'app-manual-order',
  templateUrl: './manual-order.component.html',
  styleUrl: './manual-order.component.css',
})
export class ManualOrderComponent implements OnInit, AfterViewInit {
  @ViewChild('addressInput', { static: false }) addressInput!: ElementRef;

  manualOrderForm: FormGroup;
  isLoading: boolean = false;
  currentUser: any;

  private orderNumberMarketMap: { [key: string]: string } = {
    '0101': 'PEN',
    '1-': 'NNE',
    '0000': 'ALT',
    '0053': 'CAL',
    '0102': 'CON',
    '0012': 'ILL',
    '0021': 'KAT',
    '0231': 'LUF',
    '0071': 'MIN',
  };

  constructor(private fb: FormBuilder, private data: DataserviceService) {
    this.manualOrderForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
      city: [''],
      state: [''],
      zip: [''],
      orderNumber: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    // console.log('current user: ', this.currentUser)
  }

  ngAfterViewInit() {
    this.initPlaceAutocomplete();
  }

  private initPlaceAutocomplete(): void {
    if (!this.addressInput) return;

    const autocomplete = new google.maps.places.Autocomplete(this.addressInput.nativeElement, {
      types: ['address'],
      componentRestrictions: { country: 'us' },
    });

    autocomplete.addListener('place_changed', () => {
      // const place = autocomplete.getPlace();
      let place: any;

      if (place?.address_components) {
        const addressComponents = this.parseAddressComponents(place.address_components);

        this.manualOrderForm.patchValue({
          address: addressComponents.streetAddress,
          city: addressComponents.city,
          state: addressComponents.state,
          zip: addressComponents.zipCode
        });
      }
    });
  }

  private parseAddressComponents(components: any[]): any {
    let streetNumber = '';
    let route = '';
    let city = '';
    let state = '';
    let zipCode = '';

    for (const component of components) {
      const componentType = component.types[0];

      switch (componentType) {
        case 'street_number':
          streetNumber = component.long_name;
          break;
        case 'route':
          route = component.long_name;
          break;
        case 'locality':
          city = component.long_name;
          break;
        case 'administrative_area_level_1':
          state = component.short_name;
          break;
        case 'postal_code':
          zipCode = component.long_name;
          break;
      }
    }

    return {
      streetAddress: `${streetNumber} ${route}`.trim(),
      city,
      state,
      zipCode,
    };
  }

  private determineMarket(orderNumber: string): string {
    if (!orderNumber) return 'Unknown';

    const prefix = Object.keys(this.orderNumberMarketMap).find((key) => orderNumber.startsWith(key));
    return prefix ? this.orderNumberMarketMap[prefix] : 'Unknown';
  }

  createManualOrder() {
    this.isLoading = true;

    const formValues = this.manualOrderForm.value;

    const market = this.determineMarket(formValues.orderNumber);

    const customerData = {
      first: formValues.firstName,
      last: formValues.lastName,
      address: formValues.address,
      city: formValues.city,
      state: formValues.state,
      zip: formValues.zip,
      email: formValues.email || null,
      phone: formValues.phone || null,
      company: this.currentUser.company_id,
      user_id: this.currentUser.id,
      distributor: this.currentUser.distributor_id
    };

    const checkOrderObject = {
      orderNumber: formValues.orderNumber,
      customerData: customerData,
    };

    this.data.postData(checkOrderObject, 'work-order/manual-create').subscribe(
      (response) => {
  
        if(response.result == 'error' ){
          this.data.createMessage('warning', `${response.message}`)
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.data.createMessage('success', `${response.message}`);
          this.resetForm();
        }
      },
      (error) => {
        this.data.createMessage('error', 'Failed to create order. Please try again.');
        console.log(formValues)
        this.isLoading = false;
      }
    );
  }

  resetForm() {
    this.manualOrderForm.reset();
    this.addressInput.nativeElement.value = '';
  }
}
